/** Aiuti comuni ai voti dell'allenamento (V15) e della partita (V27). */

/** Media a un decimale dei voti dati, null se nessuno. */
export function mediaVoti(voti: readonly (number | null)[]): number | null {
  const dati = voti.filter((v): v is number => v !== null);
  if (dati.length === 0) return null;
  return Math.round((dati.reduce((a, b) => a + b, 0) / dati.length) * 10) / 10;
}
